<template>
  <div class="tabs">
    <div class="tabs-wrapper" v-if="tabs">
      <span
        v-for="tab in tabs"
        :key="tab.id"
        class="tabs-wrapper__item"
        :class="{ active: selectedTab.id === tab.id }"
        @click="handleSelectTab(tab)"
        >{{ tab.name }}</span
      >
      <div
        class="tabs-wrapper__indicator"
        :style="{ backgroundColor: primary, ...selectedTab.indicatorStyle }"
      ></div>
    </div>
  </div>
</template>

<script>
import { memberTabs, productTabs } from "../helpers/variables";
import _ from "lodash";
export default {
  name: "admin-tabs",
  props: {
    module: {
      type: String,
      default: ""
    },
    current: {
      type: Number,
      default: 0
    }
  },
  watch: {
    current() {
      this.selectedTab = _.find(this.tabs, { id: this.current });
    }
  },
  data: () => ({
    selectedTab: null,
    tabs: null
  }),
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      switch (this.module) {
        case "products":
          this.tabs = productTabs;
          break;
        case "members":
          this.tabs = memberTabs;
          break;
      }
      this.handleSelectTab(this.tabs[0]);
    },
    handleSelectTab(tab) {
      this.selectedTab = tab;
      if (this.selectedTab.slug == "groups") {
        this.$store.dispatch("HISTORY_ACTIVE_USER", null);
      }
      this.$emit("selected", tab);
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  border-bottom: 1px solid $gray-250;
  width: 100%;
  &-wrapper {
    padding: 20px 0;
    position: relative;
    &__item {
      color: $gray-500;
      cursor: pointer;
      font-family: "Gotham";
      font-weight: 500;
      font-size: $font-size-base;
      margin-right: 40px;
      position: relative;
      transition: all 0.2s ease;
      &.active {
        color: $gray-900;
      }
    }
    &:last-child {
      margin-right: 0;
    }
    &__indicator {
      bottom: 0;
      content: "";
      height: 2px;
      position: absolute;
      transition: all 0.2s ease-in-out;
      width: 100%;
    }
  }
}
</style>
